import { useMemo, useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../../src/store/global-selectors';
import { getOrderStatusFromViewName } from '../../../services/api/order-status-from-view-service';
import { ContextWrappedAutoBatchingModal } from '../../../../src/pages/orders-page/auto-batch-modal/context-wrapped-modal';
import { ModalService } from 'ui-components/services/modal-service';
import { FiltersContext } from '../../../filters/context';
import { useAutoBatchingFeatureGate } from '../../../feature-gates/use-auto-batching-feature-gate';
import { messages } from './messages';
import { useSelectedOrdersView, useTopLevelOrdersViewId } from '../../../pages/orders-page/orders-left-nav/orders-left-nav-context';

export const useAutoBatching = () => {
  const { buildApiFilters } = useContext(FiltersContext);
  const filters = buildApiFilters();
  const ordersView = useSelectedOrdersView();
  const requestStatusViewId = useTopLevelOrdersViewId();
  const selectedStoreGuid = ordersView?.storeGuid;
  const orderStatus = getOrderStatusFromViewName(requestStatusViewId);
  const totalRecords = useSelector(Global.selectOrdersGridTotalRecords);
  const { isFeatureEnabled: hasAutoBatchingFeature } = useAutoBatchingFeatureGate();
  const selectedFulfillmentPlanIds = useSelector(Global.selectSelectedOrdersIds);
  const selectedOrdersCount = useSelector(Global.selectSelectedOrdersCount) || 0;

  const actionHandler = useCallback(() => {
    ModalService.launchModal({
      component: ContextWrappedAutoBatchingModal,
      props: {
        gridFilters: {
          orderGridStatus: orderStatus,
          storeGuid: selectedStoreGuid,
          ...filters,
        },
        totalRecords: selectedFulfillmentPlanIds?.length > 0 ? selectedOrdersCount : totalRecords,
        selectedFulfillmentPlanIds,
      },
    });
  }, [filters, orderStatus, selectedFulfillmentPlanIds, selectedOrdersCount, selectedStoreGuid, totalRecords]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsAutoCreateBatches,
      isDisabled: !hasAutoBatchingFeature,
      disabledReason: hasAutoBatchingFeature ? null : messages.autoBatchingDisabledReason,
    };
  }, [actionHandler, hasAutoBatchingFeature]);
};
